export const examsInCity = [
  { name: 'Ecografia Ultrassom', slug: 'ecografia-ultrassom' },
  { name: 'Hemograma Exame de Sangue', slug: 'hemograma-exame-de-sangue' },
  { name: 'Raio-X', slug: 'raio-x' },
  { name: 'Ressonância Magnética', slug: 'ressonancia-magnetica' },
  { name: 'Tomografia', slug: 'tomografia' },
];
